import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import jaTranslations from "./i18n/locales/ja.json";
import enTranslations from "./i18n/locales/en.json";
import zhTranslations from "./i18n/locales/zh.json";

i18n.use(initReactI18next).init({
  resources: {
    ja: {
      translation: jaTranslations,
    },
    en: {
      translation: enTranslations,
    },
    zh: {
      translation: zhTranslations,
    },
  },
  lng: "ja", // デフォルト言語
  fallbackLng: "ja",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
